export default {
  sm: `
  LEED 인증
  `
};
